import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isIOS, isTablet } from 'react-device-detect';
import Brand from '../../brand';
import { SwitchLanguage } from '../../../containers/switchLanguage';
import { AppDownload } from '../appDownload';
import { useGoPrehome } from '../../../hooks/useGoPrehome';

import './index.scss';

export default function PageFrame({ children }) {
  const { pathname } = useLocation();
  const { navigateToPreHome } = useGoPrehome();

  const isIpad = isIOS && isTablet;
  const hasDownloadApp = !isIpad;

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, [pathname]);

  return (
    <>
      <div className={'pageframe_header'}>
        <header className="page-header_brand">
          <Brand onclickBrand={navigateToPreHome} />
        </header>
      </div>
      <div className="pageframe_body">
        <div className={'page-body'}>
          {children}
          <SwitchLanguage home={true} />
        </div>
        {hasDownloadApp && <AppDownload />}
      </div>
    </>
  );
}
